var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4613 24.978V22.382L18.1053 16.486C18.604 16.046 18.956 15.6317 19.1613 15.243C19.3667 14.8543 19.4693 14.4913 19.4693 14.154C19.4693 13.67 19.3703 13.241 19.1723 12.867C18.9743 12.4857 18.6957 12.1887 18.3363 11.976C17.977 11.756 17.5553 11.646 17.0713 11.646C16.5653 11.646 16.118 11.7633 15.7293 11.998C15.348 12.2253 15.051 12.5297 14.8383 12.911C14.6257 13.285 14.5267 13.692 14.5413 14.132H11.4613C11.4613 13.0467 11.6997 12.108 12.1763 11.316C12.653 10.524 13.3167 9.91167 14.1673 9.479C15.018 9.04633 16.008 8.83 17.1373 8.83C18.1713 8.83 19.0953 9.05733 19.9093 9.512C20.7307 9.95933 21.376 10.5863 21.8453 11.393C22.3147 12.1997 22.5493 13.1347 22.5493 14.198C22.5493 14.9827 22.4393 15.6353 22.2193 16.156C21.9993 16.6693 21.673 17.146 21.2403 17.586C20.8077 18.0187 20.276 18.51 19.6453 19.06L15.3553 22.822L15.1133 22.162H22.5493V24.978H11.4613Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "#2B65CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2d.18294e6887a9ddaa3db07fa7609278b4.svg";
export { ForwardRef as ReactComponent };